<section
  class="incomplete-profile-banner"
  *ngIf="visible"
  [attr.aria-label]="'PROFILE_PAGE.BANNER_ARIA' | translate"
>
  <div class="incomplete-profile-banner__top">
    <div class="incomplete-profile-banner__title-row">
      <div class="incomplete-profile-banner__avatar" aria-hidden="true">
        <mat-icon svgIcon="person"></mat-icon>
      </div>
      <p class="incomplete-profile-banner__title">
        {{
          'PROFILE_PAGE.BANNER_TITLE'
            | translate : { percent: completionPercentage }
        }}
      </p>
    </div>

    <div class="incomplete-profile-banner__actions">
      <button
        type="button"
        class="incomplete-profile-banner__btn incomplete-profile-banner__btn--primary"
        (click)="completeAndEarn()"
      >
        <span>{{ 'PROFILE_PAGE.BANNER_CTA' | translate }}</span>
        <img
          src="./assets/img/isotipo.svg"
          alt=""
          width="24"
          height="24"
          aria-hidden="true"
        />
      </button>
      <button
        type="button"
        class="incomplete-profile-banner__btn incomplete-profile-banner__btn--ghost"
        (click)="snooze()"
      >
        {{ 'PROFILE_PAGE.BANNER_LATER' | translate }}
      </button>
    </div>
  </div>

  <p class="incomplete-profile-banner__copy">
    {{ 'PROFILE_PAGE.BANNER_COPY_BEFORE' | translate }}
    <strong>{{
      'PROFILE_PAGE.PROGRESS_HINT_POINTS' | translate : { points: rewardPoints }
    }}</strong>
    {{ 'PROFILE_PAGE.BANNER_COPY_AFTER' | translate }}
  </p>

  <div class="incomplete-profile-banner__progress">
    <p class="incomplete-profile-banner__percent">
      {{
        'PROFILE_PAGE.BANNER_PERCENT'
          | translate : { percent: completionPercentage }
      }}
    </p>
    <div
      class="incomplete-profile-banner__bar"
      role="progressbar"
      [attr.aria-valuenow]="completionPercentage"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div
        class="incomplete-profile-banner__bar-fill"
        [style.width.%]="completionPercentage"
      ></div>
    </div>
    <ul class="incomplete-profile-banner__steps">
      <li
        *ngFor="let step of steps"
        class="incomplete-profile-banner__step"
        [class.incomplete-profile-banner__step--done]="step.completed"
      >
        <mat-icon
          *ngIf="step.completed"
          class="incomplete-profile-banner__step-icon"
          svgIcon="check_circle"
        ></mat-icon>
        <span
          *ngIf="!step.completed"
          class="incomplete-profile-banner__step-circle"
          aria-hidden="true"
        ></span>
        <span>{{ step.labelKey | translate }}</span>
      </li>
    </ul>
  </div>
</section>
